// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'documents'

/**
 * Document Model Interface (auto-generated from Drizzle schema)
 */
export interface DocumentModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  projectId: string
  milestoneId: string
  taskId: string
  codebaseId: string
  documentType: string
  title: string
  content?: string
  storage?: Record<string, unknown>
  documentVersion: number
  approved: boolean
  approvedAt?: string
  approvedBy?: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "projectId": {
          "type": "string",
          "maxLength": 100
      },
      "milestoneId": {
          "type": "string",
          "maxLength": 100
      },
      "taskId": {
          "type": "string",
          "maxLength": 100
      },
      "codebaseId": {
          "type": "string",
          "maxLength": 100
      },
      "documentType": {
          "type": "string",
          "maxLength": 200
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "content": {
          "type": "string",
          "maxLength": 100000
      },
      "storage": {
          "type": "object"
      },
      "documentVersion": {
          "type": "integer"
      },
      "approved": {
          "type": "boolean"
      },
      "approvedAt": {
          "type": "string",
          "maxLength": 200
      },
      "approvedBy": {
          "type": "string",
          "maxLength": 200
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "documentType",
      "title",
      "documentVersion",
      "approved",
      "workspaceId",
      "projectId",
      "milestoneId",
      "taskId",
      "codebaseId"
  ],
  indexes: [
      [
          "orgId",
          "createdAt"
      ],
      [
          "workspaceId",
          "createdAt"
      ],
      [
          "projectId",
          "createdAt"
      ],
      [
          "milestoneId",
          "createdAt"
      ],
      [
          "taskId",
          "createdAt"
      ],
      [
          "codebaseId",
          "createdAt"
      ],
      [
          "orgId",
          "documentType",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
